/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteRouteImport } from './routes/_login/route'
import { Route as AuthedRouteRouteImport } from './routes/_authed/route'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as LoginResetPasswordRouteImport } from './routes/_login/reset-password'
import { Route as LoginLoginRouteImport } from './routes/_login/login'
import { Route as LoginCreateAccountRouteImport } from './routes/_login/create-account'
import { Route as AuthedWeldingRouteImport } from './routes/_authed/welding'
import { Route as AuthedRfidRouteImport } from './routes/_authed/rfid'
import { Route as AuthedProductionStorageLookupRouteImport } from './routes/_authed/production-storage-lookup'
import { Route as AuthedProductionStorageRouteImport } from './routes/_authed/production-storage'
import { Route as AuthedPowerRouteImport } from './routes/_authed/power'
import { Route as AuthedNcrRouteImport } from './routes/_authed/ncr'
import { Route as AuthedMachineryRouteImport } from './routes/_authed/machinery'
import { Route as AuthedJobCheckRouteImport } from './routes/_authed/job-check'
import { Route as AuthedIotRouteImport } from './routes/_authed/iot'
import { Route as AuthedInventoryRouteImport } from './routes/_authed/inventory'
import { Route as AuthedGhgRouteImport } from './routes/_authed/ghg'
import { Route as AuthedJobOverviewRouteImport } from './routes/_authed/JobOverview'
import { Route as AuthedSmartcellRouteRouteImport } from './routes/_authed/smartcell/route'
import { Route as AuthedDrawerLayoutRouteRouteImport } from './routes/_authed/_drawerLayout/route'
import { Route as AuthedSmartcellIndexRouteImport } from './routes/_authed/smartcell/index'
import { Route as AuthedMachineryIndexRouteImport } from './routes/_authed/machinery/index'
import { Route as KanbanOrderApprovalTokenRouteImport } from './routes/kanban/order-approval/$token'
import { Route as AuthedSmartcellIdRouteImport } from './routes/_authed/smartcell/$id'
import { Route as AuthedMachineryInspectionReportsRouteImport } from './routes/_authed/machinery/inspection-reports'
import { Route as AuthedMachineryInspectionRouteImport } from './routes/_authed/machinery/inspection'
import { Route as AuthedMachineryForkliftRouteImport } from './routes/_authed/machinery/forklift'
import { Route as AuthedMachineryCraneRouteImport } from './routes/_authed/machinery/crane'
import { Route as AuthedKanbanChar123IdChar125RouteImport } from './routes/_authed/kanban.{-$id}'
import { Route as AuthedHelpAddNewRouteImport } from './routes/_authed/help/add-new'
import { Route as AuthedHelpSectionRouteImport } from './routes/_authed/help/$section'
import { Route as AuthedAdminInviteUserRouteImport } from './routes/_authed/admin/invite-user'
import { Route as AuthedAdminTenantPermissionRouteImport } from './routes/_authed/admin/TenantPermission'
import { Route as AuthedDrawerLayoutProjectOverviewRouteImport } from './routes/_authed/_drawerLayout/ProjectOverview'
import { Route as AuthedDeviceDetailsIdRouteImport } from './routes/_authed/DeviceDetails.$id'
import { Route as AuthedDrawerLayoutSettingsUserRouteRouteImport } from './routes/_authed/_drawerLayout/settings/user/route'
import { Route as AuthedDrawerLayoutAdminUserRouteRouteImport } from './routes/_authed/_drawerLayout/admin/user/route'
import { Route as AuthedDrawerLayoutAdminPlantRouteRouteImport } from './routes/_authed/_drawerLayout/admin/plant/route'
import { Route as AuthedDrawerLayoutAdminNotificationRouteRouteImport } from './routes/_authed/_drawerLayout/admin/notification/route'
import { Route as AuthedDrawerLayoutAdminMachineryRouteRouteImport } from './routes/_authed/_drawerLayout/admin/machinery/route'
import { Route as AuthedDrawerLayoutAdminCellRouteRouteImport } from './routes/_authed/_drawerLayout/admin/cell/route'
import { Route as AuthedDrawerLayoutSettingsUserIndexRouteImport } from './routes/_authed/_drawerLayout/settings/user/index'
import { Route as AuthedDrawerLayoutAdminUserIndexRouteImport } from './routes/_authed/_drawerLayout/admin/user/index'
import { Route as AuthedDrawerLayoutAdminPlantIndexRouteImport } from './routes/_authed/_drawerLayout/admin/plant/index'
import { Route as AuthedDrawerLayoutAdminNotificationIndexRouteImport } from './routes/_authed/_drawerLayout/admin/notification/index'
import { Route as AuthedDrawerLayoutAdminMachineryIndexRouteImport } from './routes/_authed/_drawerLayout/admin/machinery/index'
import { Route as AuthedDrawerLayoutAdminCellIndexRouteImport } from './routes/_authed/_drawerLayout/admin/cell/index'
import { Route as AuthedDrawerLayoutSettingsUserSecurityRouteImport } from './routes/_authed/_drawerLayout/settings/user/security'
import { Route as AuthedDrawerLayoutSettingsUserProfileRouteImport } from './routes/_authed/_drawerLayout/settings/user/profile'
import { Route as AuthedDrawerLayoutAdminUserIdRouteImport } from './routes/_authed/_drawerLayout/admin/user/$id'
import { Route as AuthedDrawerLayoutAdminPlantAddNewRouteImport } from './routes/_authed/_drawerLayout/admin/plant/add-new'
import { Route as AuthedDrawerLayoutAdminPlantIdRouteImport } from './routes/_authed/_drawerLayout/admin/plant/$id'
import { Route as AuthedDrawerLayoutAdminNotificationKanbanOrderApprovalRouteImport } from './routes/_authed/_drawerLayout/admin/notification/kanban-order-approval'
import { Route as AuthedDrawerLayoutAdminNotificationJobNotificationRouteImport } from './routes/_authed/_drawerLayout/admin/notification/job-notification'
import { Route as AuthedDrawerLayoutAdminNotificationIotHeartbeatRouteImport } from './routes/_authed/_drawerLayout/admin/notification/iot-heartbeat'
import { Route as AuthedDrawerLayoutAdminNotificationEmailRouteImport } from './routes/_authed/_drawerLayout/admin/notification/email'
import { Route as AuthedDrawerLayoutAdminNotificationCallHelpRouteImport } from './routes/_authed/_drawerLayout/admin/notification/call-help'
import { Route as AuthedDrawerLayoutAdminCellAddNewRouteImport } from './routes/_authed/_drawerLayout/admin/cell/add-new'
import { Route as AuthedDrawerLayoutAdminCellIdRouteImport } from './routes/_authed/_drawerLayout/admin/cell/$id'
import { Route as AuthedDrawerLayoutAdminMachineryMachinesAddNewRouteImport } from './routes/_authed/_drawerLayout/admin/machinery/machines/add-new'
import { Route as AuthedDrawerLayoutAdminMachineryMachinesIdRouteImport } from './routes/_authed/_drawerLayout/admin/machinery/machines/$id'

const LoginRouteRoute = LoginRouteRouteImport.update({
  id: '/_login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRouteRoute = AuthedRouteRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const LoginResetPasswordRoute = LoginResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => LoginRouteRoute,
} as any)
const LoginLoginRoute = LoginLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => LoginRouteRoute,
} as any)
const LoginCreateAccountRoute = LoginCreateAccountRouteImport.update({
  id: '/create-account',
  path: '/create-account',
  getParentRoute: () => LoginRouteRoute,
} as any)
const AuthedWeldingRoute = AuthedWeldingRouteImport.update({
  id: '/welding',
  path: '/welding',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedRfidRoute = AuthedRfidRouteImport.update({
  id: '/rfid',
  path: '/rfid',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedProductionStorageLookupRoute =
  AuthedProductionStorageLookupRouteImport.update({
    id: '/production-storage-lookup',
    path: '/production-storage-lookup',
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedProductionStorageRoute = AuthedProductionStorageRouteImport.update({
  id: '/production-storage',
  path: '/production-storage',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedPowerRoute = AuthedPowerRouteImport.update({
  id: '/power',
  path: '/power',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedNcrRoute = AuthedNcrRouteImport.update({
  id: '/ncr',
  path: '/ncr',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedMachineryRoute = AuthedMachineryRouteImport.update({
  id: '/machinery',
  path: '/machinery',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedJobCheckRoute = AuthedJobCheckRouteImport.update({
  id: '/job-check',
  path: '/job-check',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedIotRoute = AuthedIotRouteImport.update({
  id: '/iot',
  path: '/iot',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedInventoryRoute = AuthedInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedGhgRoute = AuthedGhgRouteImport.update({
  id: '/ghg',
  path: '/ghg',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedJobOverviewRoute = AuthedJobOverviewRouteImport.update({
  id: '/JobOverview',
  path: '/JobOverview',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedSmartcellRouteRoute = AuthedSmartcellRouteRouteImport.update({
  id: '/smartcell',
  path: '/smartcell',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedDrawerLayoutRouteRoute = AuthedDrawerLayoutRouteRouteImport.update({
  id: '/_drawerLayout',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedSmartcellIndexRoute = AuthedSmartcellIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedSmartcellRouteRoute,
} as any)
const AuthedMachineryIndexRoute = AuthedMachineryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedMachineryRoute,
} as any)
const KanbanOrderApprovalTokenRoute =
  KanbanOrderApprovalTokenRouteImport.update({
    id: '/kanban/order-approval/$token',
    path: '/kanban/order-approval/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthedSmartcellIdRoute = AuthedSmartcellIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedSmartcellRouteRoute,
} as any)
const AuthedMachineryInspectionReportsRoute =
  AuthedMachineryInspectionReportsRouteImport.update({
    id: '/inspection-reports',
    path: '/inspection-reports',
    getParentRoute: () => AuthedMachineryRoute,
  } as any)
const AuthedMachineryInspectionRoute =
  AuthedMachineryInspectionRouteImport.update({
    id: '/inspection',
    path: '/inspection',
    getParentRoute: () => AuthedMachineryRoute,
  } as any)
const AuthedMachineryForkliftRoute = AuthedMachineryForkliftRouteImport.update({
  id: '/forklift',
  path: '/forklift',
  getParentRoute: () => AuthedMachineryRoute,
} as any)
const AuthedMachineryCraneRoute = AuthedMachineryCraneRouteImport.update({
  id: '/crane',
  path: '/crane',
  getParentRoute: () => AuthedMachineryRoute,
} as any)
const AuthedKanbanChar123IdChar125Route =
  AuthedKanbanChar123IdChar125RouteImport.update({
    id: '/kanban/{-$id}',
    path: '/kanban/{-$id}',
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedHelpAddNewRoute = AuthedHelpAddNewRouteImport.update({
  id: '/help/add-new',
  path: '/help/add-new',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedHelpSectionRoute = AuthedHelpSectionRouteImport.update({
  id: '/help/$section',
  path: '/help/$section',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAdminInviteUserRoute = AuthedAdminInviteUserRouteImport.update({
  id: '/admin/invite-user',
  path: '/admin/invite-user',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedAdminTenantPermissionRoute =
  AuthedAdminTenantPermissionRouteImport.update({
    id: '/admin/TenantPermission',
    path: '/admin/TenantPermission',
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedDrawerLayoutProjectOverviewRoute =
  AuthedDrawerLayoutProjectOverviewRouteImport.update({
    id: '/ProjectOverview',
    path: '/ProjectOverview',
    getParentRoute: () => AuthedDrawerLayoutRouteRoute,
  } as any)
const AuthedDeviceDetailsIdRoute = AuthedDeviceDetailsIdRouteImport.update({
  id: '/DeviceDetails/$id',
  path: '/DeviceDetails/$id',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedDrawerLayoutSettingsUserRouteRoute =
  AuthedDrawerLayoutSettingsUserRouteRouteImport.update({
    id: '/settings/user',
    path: '/settings/user',
    getParentRoute: () => AuthedDrawerLayoutRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminUserRouteRoute =
  AuthedDrawerLayoutAdminUserRouteRouteImport.update({
    id: '/admin/user',
    path: '/admin/user',
    getParentRoute: () => AuthedDrawerLayoutRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminPlantRouteRoute =
  AuthedDrawerLayoutAdminPlantRouteRouteImport.update({
    id: '/admin/plant',
    path: '/admin/plant',
    getParentRoute: () => AuthedDrawerLayoutRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminNotificationRouteRoute =
  AuthedDrawerLayoutAdminNotificationRouteRouteImport.update({
    id: '/admin/notification',
    path: '/admin/notification',
    getParentRoute: () => AuthedDrawerLayoutRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminMachineryRouteRoute =
  AuthedDrawerLayoutAdminMachineryRouteRouteImport.update({
    id: '/admin/machinery',
    path: '/admin/machinery',
    getParentRoute: () => AuthedDrawerLayoutRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminCellRouteRoute =
  AuthedDrawerLayoutAdminCellRouteRouteImport.update({
    id: '/admin/cell',
    path: '/admin/cell',
    getParentRoute: () => AuthedDrawerLayoutRouteRoute,
  } as any)
const AuthedDrawerLayoutSettingsUserIndexRoute =
  AuthedDrawerLayoutSettingsUserIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDrawerLayoutSettingsUserRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminUserIndexRoute =
  AuthedDrawerLayoutAdminUserIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDrawerLayoutAdminUserRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminPlantIndexRoute =
  AuthedDrawerLayoutAdminPlantIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDrawerLayoutAdminPlantRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminNotificationIndexRoute =
  AuthedDrawerLayoutAdminNotificationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDrawerLayoutAdminNotificationRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminMachineryIndexRoute =
  AuthedDrawerLayoutAdminMachineryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDrawerLayoutAdminMachineryRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminCellIndexRoute =
  AuthedDrawerLayoutAdminCellIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDrawerLayoutAdminCellRouteRoute,
  } as any)
const AuthedDrawerLayoutSettingsUserSecurityRoute =
  AuthedDrawerLayoutSettingsUserSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthedDrawerLayoutSettingsUserRouteRoute,
  } as any)
const AuthedDrawerLayoutSettingsUserProfileRoute =
  AuthedDrawerLayoutSettingsUserProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthedDrawerLayoutSettingsUserRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminUserIdRoute =
  AuthedDrawerLayoutAdminUserIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthedDrawerLayoutAdminUserRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminPlantAddNewRoute =
  AuthedDrawerLayoutAdminPlantAddNewRouteImport.update({
    id: '/add-new',
    path: '/add-new',
    getParentRoute: () => AuthedDrawerLayoutAdminPlantRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminPlantIdRoute =
  AuthedDrawerLayoutAdminPlantIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthedDrawerLayoutAdminPlantRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminNotificationKanbanOrderApprovalRoute =
  AuthedDrawerLayoutAdminNotificationKanbanOrderApprovalRouteImport.update({
    id: '/kanban-order-approval',
    path: '/kanban-order-approval',
    getParentRoute: () => AuthedDrawerLayoutAdminNotificationRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminNotificationJobNotificationRoute =
  AuthedDrawerLayoutAdminNotificationJobNotificationRouteImport.update({
    id: '/job-notification',
    path: '/job-notification',
    getParentRoute: () => AuthedDrawerLayoutAdminNotificationRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminNotificationIotHeartbeatRoute =
  AuthedDrawerLayoutAdminNotificationIotHeartbeatRouteImport.update({
    id: '/iot-heartbeat',
    path: '/iot-heartbeat',
    getParentRoute: () => AuthedDrawerLayoutAdminNotificationRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminNotificationEmailRoute =
  AuthedDrawerLayoutAdminNotificationEmailRouteImport.update({
    id: '/email',
    path: '/email',
    getParentRoute: () => AuthedDrawerLayoutAdminNotificationRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminNotificationCallHelpRoute =
  AuthedDrawerLayoutAdminNotificationCallHelpRouteImport.update({
    id: '/call-help',
    path: '/call-help',
    getParentRoute: () => AuthedDrawerLayoutAdminNotificationRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminCellAddNewRoute =
  AuthedDrawerLayoutAdminCellAddNewRouteImport.update({
    id: '/add-new',
    path: '/add-new',
    getParentRoute: () => AuthedDrawerLayoutAdminCellRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminCellIdRoute =
  AuthedDrawerLayoutAdminCellIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthedDrawerLayoutAdminCellRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminMachineryMachinesAddNewRoute =
  AuthedDrawerLayoutAdminMachineryMachinesAddNewRouteImport.update({
    id: '/machines/add-new',
    path: '/machines/add-new',
    getParentRoute: () => AuthedDrawerLayoutAdminMachineryRouteRoute,
  } as any)
const AuthedDrawerLayoutAdminMachineryMachinesIdRoute =
  AuthedDrawerLayoutAdminMachineryMachinesIdRouteImport.update({
    id: '/machines/$id',
    path: '/machines/$id',
    getParentRoute: () => AuthedDrawerLayoutAdminMachineryRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/smartcell': typeof AuthedSmartcellRouteRouteWithChildren
  '/JobOverview': typeof AuthedJobOverviewRoute
  '/ghg': typeof AuthedGhgRoute
  '/inventory': typeof AuthedInventoryRoute
  '/iot': typeof AuthedIotRoute
  '/job-check': typeof AuthedJobCheckRoute
  '/machinery': typeof AuthedMachineryRouteWithChildren
  '/ncr': typeof AuthedNcrRoute
  '/power': typeof AuthedPowerRoute
  '/production-storage': typeof AuthedProductionStorageRoute
  '/production-storage-lookup': typeof AuthedProductionStorageLookupRoute
  '/rfid': typeof AuthedRfidRoute
  '/welding': typeof AuthedWeldingRoute
  '/create-account': typeof LoginCreateAccountRoute
  '/login': typeof LoginLoginRoute
  '/reset-password': typeof LoginResetPasswordRoute
  '/DeviceDetails/$id': typeof AuthedDeviceDetailsIdRoute
  '/ProjectOverview': typeof AuthedDrawerLayoutProjectOverviewRoute
  '/admin/TenantPermission': typeof AuthedAdminTenantPermissionRoute
  '/admin/invite-user': typeof AuthedAdminInviteUserRoute
  '/help/$section': typeof AuthedHelpSectionRoute
  '/help/add-new': typeof AuthedHelpAddNewRoute
  '/kanban/{-$id}': typeof AuthedKanbanChar123IdChar125Route
  '/machinery/crane': typeof AuthedMachineryCraneRoute
  '/machinery/forklift': typeof AuthedMachineryForkliftRoute
  '/machinery/inspection': typeof AuthedMachineryInspectionRoute
  '/machinery/inspection-reports': typeof AuthedMachineryInspectionReportsRoute
  '/smartcell/$id': typeof AuthedSmartcellIdRoute
  '/kanban/order-approval/$token': typeof KanbanOrderApprovalTokenRoute
  '/machinery/': typeof AuthedMachineryIndexRoute
  '/smartcell/': typeof AuthedSmartcellIndexRoute
  '/admin/cell': typeof AuthedDrawerLayoutAdminCellRouteRouteWithChildren
  '/admin/machinery': typeof AuthedDrawerLayoutAdminMachineryRouteRouteWithChildren
  '/admin/notification': typeof AuthedDrawerLayoutAdminNotificationRouteRouteWithChildren
  '/admin/plant': typeof AuthedDrawerLayoutAdminPlantRouteRouteWithChildren
  '/admin/user': typeof AuthedDrawerLayoutAdminUserRouteRouteWithChildren
  '/settings/user': typeof AuthedDrawerLayoutSettingsUserRouteRouteWithChildren
  '/admin/cell/$id': typeof AuthedDrawerLayoutAdminCellIdRoute
  '/admin/cell/add-new': typeof AuthedDrawerLayoutAdminCellAddNewRoute
  '/admin/notification/call-help': typeof AuthedDrawerLayoutAdminNotificationCallHelpRoute
  '/admin/notification/email': typeof AuthedDrawerLayoutAdminNotificationEmailRoute
  '/admin/notification/iot-heartbeat': typeof AuthedDrawerLayoutAdminNotificationIotHeartbeatRoute
  '/admin/notification/job-notification': typeof AuthedDrawerLayoutAdminNotificationJobNotificationRoute
  '/admin/notification/kanban-order-approval': typeof AuthedDrawerLayoutAdminNotificationKanbanOrderApprovalRoute
  '/admin/plant/$id': typeof AuthedDrawerLayoutAdminPlantIdRoute
  '/admin/plant/add-new': typeof AuthedDrawerLayoutAdminPlantAddNewRoute
  '/admin/user/$id': typeof AuthedDrawerLayoutAdminUserIdRoute
  '/settings/user/profile': typeof AuthedDrawerLayoutSettingsUserProfileRoute
  '/settings/user/security': typeof AuthedDrawerLayoutSettingsUserSecurityRoute
  '/admin/cell/': typeof AuthedDrawerLayoutAdminCellIndexRoute
  '/admin/machinery/': typeof AuthedDrawerLayoutAdminMachineryIndexRoute
  '/admin/notification/': typeof AuthedDrawerLayoutAdminNotificationIndexRoute
  '/admin/plant/': typeof AuthedDrawerLayoutAdminPlantIndexRoute
  '/admin/user/': typeof AuthedDrawerLayoutAdminUserIndexRoute
  '/settings/user/': typeof AuthedDrawerLayoutSettingsUserIndexRoute
  '/admin/machinery/machines/$id': typeof AuthedDrawerLayoutAdminMachineryMachinesIdRoute
  '/admin/machinery/machines/add-new': typeof AuthedDrawerLayoutAdminMachineryMachinesAddNewRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthedIndexRoute
  '/JobOverview': typeof AuthedJobOverviewRoute
  '/ghg': typeof AuthedGhgRoute
  '/inventory': typeof AuthedInventoryRoute
  '/iot': typeof AuthedIotRoute
  '/job-check': typeof AuthedJobCheckRoute
  '/ncr': typeof AuthedNcrRoute
  '/power': typeof AuthedPowerRoute
  '/production-storage': typeof AuthedProductionStorageRoute
  '/production-storage-lookup': typeof AuthedProductionStorageLookupRoute
  '/rfid': typeof AuthedRfidRoute
  '/welding': typeof AuthedWeldingRoute
  '/create-account': typeof LoginCreateAccountRoute
  '/login': typeof LoginLoginRoute
  '/reset-password': typeof LoginResetPasswordRoute
  '/DeviceDetails/$id': typeof AuthedDeviceDetailsIdRoute
  '/ProjectOverview': typeof AuthedDrawerLayoutProjectOverviewRoute
  '/admin/TenantPermission': typeof AuthedAdminTenantPermissionRoute
  '/admin/invite-user': typeof AuthedAdminInviteUserRoute
  '/help/$section': typeof AuthedHelpSectionRoute
  '/help/add-new': typeof AuthedHelpAddNewRoute
  '/kanban/{-$id}': typeof AuthedKanbanChar123IdChar125Route
  '/machinery/crane': typeof AuthedMachineryCraneRoute
  '/machinery/forklift': typeof AuthedMachineryForkliftRoute
  '/machinery/inspection': typeof AuthedMachineryInspectionRoute
  '/machinery/inspection-reports': typeof AuthedMachineryInspectionReportsRoute
  '/smartcell/$id': typeof AuthedSmartcellIdRoute
  '/kanban/order-approval/$token': typeof KanbanOrderApprovalTokenRoute
  '/machinery': typeof AuthedMachineryIndexRoute
  '/smartcell': typeof AuthedSmartcellIndexRoute
  '/admin/cell/$id': typeof AuthedDrawerLayoutAdminCellIdRoute
  '/admin/cell/add-new': typeof AuthedDrawerLayoutAdminCellAddNewRoute
  '/admin/notification/call-help': typeof AuthedDrawerLayoutAdminNotificationCallHelpRoute
  '/admin/notification/email': typeof AuthedDrawerLayoutAdminNotificationEmailRoute
  '/admin/notification/iot-heartbeat': typeof AuthedDrawerLayoutAdminNotificationIotHeartbeatRoute
  '/admin/notification/job-notification': typeof AuthedDrawerLayoutAdminNotificationJobNotificationRoute
  '/admin/notification/kanban-order-approval': typeof AuthedDrawerLayoutAdminNotificationKanbanOrderApprovalRoute
  '/admin/plant/$id': typeof AuthedDrawerLayoutAdminPlantIdRoute
  '/admin/plant/add-new': typeof AuthedDrawerLayoutAdminPlantAddNewRoute
  '/admin/user/$id': typeof AuthedDrawerLayoutAdminUserIdRoute
  '/settings/user/profile': typeof AuthedDrawerLayoutSettingsUserProfileRoute
  '/settings/user/security': typeof AuthedDrawerLayoutSettingsUserSecurityRoute
  '/admin/cell': typeof AuthedDrawerLayoutAdminCellIndexRoute
  '/admin/machinery': typeof AuthedDrawerLayoutAdminMachineryIndexRoute
  '/admin/notification': typeof AuthedDrawerLayoutAdminNotificationIndexRoute
  '/admin/plant': typeof AuthedDrawerLayoutAdminPlantIndexRoute
  '/admin/user': typeof AuthedDrawerLayoutAdminUserIndexRoute
  '/settings/user': typeof AuthedDrawerLayoutSettingsUserIndexRoute
  '/admin/machinery/machines/$id': typeof AuthedDrawerLayoutAdminMachineryMachinesIdRoute
  '/admin/machinery/machines/add-new': typeof AuthedDrawerLayoutAdminMachineryMachinesAddNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteRouteWithChildren
  '/_login': typeof LoginRouteRouteWithChildren
  '/_authed/_drawerLayout': typeof AuthedDrawerLayoutRouteRouteWithChildren
  '/_authed/smartcell': typeof AuthedSmartcellRouteRouteWithChildren
  '/_authed/JobOverview': typeof AuthedJobOverviewRoute
  '/_authed/ghg': typeof AuthedGhgRoute
  '/_authed/inventory': typeof AuthedInventoryRoute
  '/_authed/iot': typeof AuthedIotRoute
  '/_authed/job-check': typeof AuthedJobCheckRoute
  '/_authed/machinery': typeof AuthedMachineryRouteWithChildren
  '/_authed/ncr': typeof AuthedNcrRoute
  '/_authed/power': typeof AuthedPowerRoute
  '/_authed/production-storage': typeof AuthedProductionStorageRoute
  '/_authed/production-storage-lookup': typeof AuthedProductionStorageLookupRoute
  '/_authed/rfid': typeof AuthedRfidRoute
  '/_authed/welding': typeof AuthedWeldingRoute
  '/_login/create-account': typeof LoginCreateAccountRoute
  '/_login/login': typeof LoginLoginRoute
  '/_login/reset-password': typeof LoginResetPasswordRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/DeviceDetails/$id': typeof AuthedDeviceDetailsIdRoute
  '/_authed/_drawerLayout/ProjectOverview': typeof AuthedDrawerLayoutProjectOverviewRoute
  '/_authed/admin/TenantPermission': typeof AuthedAdminTenantPermissionRoute
  '/_authed/admin/invite-user': typeof AuthedAdminInviteUserRoute
  '/_authed/help/$section': typeof AuthedHelpSectionRoute
  '/_authed/help/add-new': typeof AuthedHelpAddNewRoute
  '/_authed/kanban/{-$id}': typeof AuthedKanbanChar123IdChar125Route
  '/_authed/machinery/crane': typeof AuthedMachineryCraneRoute
  '/_authed/machinery/forklift': typeof AuthedMachineryForkliftRoute
  '/_authed/machinery/inspection': typeof AuthedMachineryInspectionRoute
  '/_authed/machinery/inspection-reports': typeof AuthedMachineryInspectionReportsRoute
  '/_authed/smartcell/$id': typeof AuthedSmartcellIdRoute
  '/kanban/order-approval/$token': typeof KanbanOrderApprovalTokenRoute
  '/_authed/machinery/': typeof AuthedMachineryIndexRoute
  '/_authed/smartcell/': typeof AuthedSmartcellIndexRoute
  '/_authed/_drawerLayout/admin/cell': typeof AuthedDrawerLayoutAdminCellRouteRouteWithChildren
  '/_authed/_drawerLayout/admin/machinery': typeof AuthedDrawerLayoutAdminMachineryRouteRouteWithChildren
  '/_authed/_drawerLayout/admin/notification': typeof AuthedDrawerLayoutAdminNotificationRouteRouteWithChildren
  '/_authed/_drawerLayout/admin/plant': typeof AuthedDrawerLayoutAdminPlantRouteRouteWithChildren
  '/_authed/_drawerLayout/admin/user': typeof AuthedDrawerLayoutAdminUserRouteRouteWithChildren
  '/_authed/_drawerLayout/settings/user': typeof AuthedDrawerLayoutSettingsUserRouteRouteWithChildren
  '/_authed/_drawerLayout/admin/cell/$id': typeof AuthedDrawerLayoutAdminCellIdRoute
  '/_authed/_drawerLayout/admin/cell/add-new': typeof AuthedDrawerLayoutAdminCellAddNewRoute
  '/_authed/_drawerLayout/admin/notification/call-help': typeof AuthedDrawerLayoutAdminNotificationCallHelpRoute
  '/_authed/_drawerLayout/admin/notification/email': typeof AuthedDrawerLayoutAdminNotificationEmailRoute
  '/_authed/_drawerLayout/admin/notification/iot-heartbeat': typeof AuthedDrawerLayoutAdminNotificationIotHeartbeatRoute
  '/_authed/_drawerLayout/admin/notification/job-notification': typeof AuthedDrawerLayoutAdminNotificationJobNotificationRoute
  '/_authed/_drawerLayout/admin/notification/kanban-order-approval': typeof AuthedDrawerLayoutAdminNotificationKanbanOrderApprovalRoute
  '/_authed/_drawerLayout/admin/plant/$id': typeof AuthedDrawerLayoutAdminPlantIdRoute
  '/_authed/_drawerLayout/admin/plant/add-new': typeof AuthedDrawerLayoutAdminPlantAddNewRoute
  '/_authed/_drawerLayout/admin/user/$id': typeof AuthedDrawerLayoutAdminUserIdRoute
  '/_authed/_drawerLayout/settings/user/profile': typeof AuthedDrawerLayoutSettingsUserProfileRoute
  '/_authed/_drawerLayout/settings/user/security': typeof AuthedDrawerLayoutSettingsUserSecurityRoute
  '/_authed/_drawerLayout/admin/cell/': typeof AuthedDrawerLayoutAdminCellIndexRoute
  '/_authed/_drawerLayout/admin/machinery/': typeof AuthedDrawerLayoutAdminMachineryIndexRoute
  '/_authed/_drawerLayout/admin/notification/': typeof AuthedDrawerLayoutAdminNotificationIndexRoute
  '/_authed/_drawerLayout/admin/plant/': typeof AuthedDrawerLayoutAdminPlantIndexRoute
  '/_authed/_drawerLayout/admin/user/': typeof AuthedDrawerLayoutAdminUserIndexRoute
  '/_authed/_drawerLayout/settings/user/': typeof AuthedDrawerLayoutSettingsUserIndexRoute
  '/_authed/_drawerLayout/admin/machinery/machines/$id': typeof AuthedDrawerLayoutAdminMachineryMachinesIdRoute
  '/_authed/_drawerLayout/admin/machinery/machines/add-new': typeof AuthedDrawerLayoutAdminMachineryMachinesAddNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/smartcell'
    | '/JobOverview'
    | '/ghg'
    | '/inventory'
    | '/iot'
    | '/job-check'
    | '/machinery'
    | '/ncr'
    | '/power'
    | '/production-storage'
    | '/production-storage-lookup'
    | '/rfid'
    | '/welding'
    | '/create-account'
    | '/login'
    | '/reset-password'
    | '/DeviceDetails/$id'
    | '/ProjectOverview'
    | '/admin/TenantPermission'
    | '/admin/invite-user'
    | '/help/$section'
    | '/help/add-new'
    | '/kanban/{-$id}'
    | '/machinery/crane'
    | '/machinery/forklift'
    | '/machinery/inspection'
    | '/machinery/inspection-reports'
    | '/smartcell/$id'
    | '/kanban/order-approval/$token'
    | '/machinery/'
    | '/smartcell/'
    | '/admin/cell'
    | '/admin/machinery'
    | '/admin/notification'
    | '/admin/plant'
    | '/admin/user'
    | '/settings/user'
    | '/admin/cell/$id'
    | '/admin/cell/add-new'
    | '/admin/notification/call-help'
    | '/admin/notification/email'
    | '/admin/notification/iot-heartbeat'
    | '/admin/notification/job-notification'
    | '/admin/notification/kanban-order-approval'
    | '/admin/plant/$id'
    | '/admin/plant/add-new'
    | '/admin/user/$id'
    | '/settings/user/profile'
    | '/settings/user/security'
    | '/admin/cell/'
    | '/admin/machinery/'
    | '/admin/notification/'
    | '/admin/plant/'
    | '/admin/user/'
    | '/settings/user/'
    | '/admin/machinery/machines/$id'
    | '/admin/machinery/machines/add-new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/JobOverview'
    | '/ghg'
    | '/inventory'
    | '/iot'
    | '/job-check'
    | '/ncr'
    | '/power'
    | '/production-storage'
    | '/production-storage-lookup'
    | '/rfid'
    | '/welding'
    | '/create-account'
    | '/login'
    | '/reset-password'
    | '/DeviceDetails/$id'
    | '/ProjectOverview'
    | '/admin/TenantPermission'
    | '/admin/invite-user'
    | '/help/$section'
    | '/help/add-new'
    | '/kanban/{-$id}'
    | '/machinery/crane'
    | '/machinery/forklift'
    | '/machinery/inspection'
    | '/machinery/inspection-reports'
    | '/smartcell/$id'
    | '/kanban/order-approval/$token'
    | '/machinery'
    | '/smartcell'
    | '/admin/cell/$id'
    | '/admin/cell/add-new'
    | '/admin/notification/call-help'
    | '/admin/notification/email'
    | '/admin/notification/iot-heartbeat'
    | '/admin/notification/job-notification'
    | '/admin/notification/kanban-order-approval'
    | '/admin/plant/$id'
    | '/admin/plant/add-new'
    | '/admin/user/$id'
    | '/settings/user/profile'
    | '/settings/user/security'
    | '/admin/cell'
    | '/admin/machinery'
    | '/admin/notification'
    | '/admin/plant'
    | '/admin/user'
    | '/settings/user'
    | '/admin/machinery/machines/$id'
    | '/admin/machinery/machines/add-new'
  id:
    | '__root__'
    | '/_authed'
    | '/_login'
    | '/_authed/_drawerLayout'
    | '/_authed/smartcell'
    | '/_authed/JobOverview'
    | '/_authed/ghg'
    | '/_authed/inventory'
    | '/_authed/iot'
    | '/_authed/job-check'
    | '/_authed/machinery'
    | '/_authed/ncr'
    | '/_authed/power'
    | '/_authed/production-storage'
    | '/_authed/production-storage-lookup'
    | '/_authed/rfid'
    | '/_authed/welding'
    | '/_login/create-account'
    | '/_login/login'
    | '/_login/reset-password'
    | '/_authed/'
    | '/_authed/DeviceDetails/$id'
    | '/_authed/_drawerLayout/ProjectOverview'
    | '/_authed/admin/TenantPermission'
    | '/_authed/admin/invite-user'
    | '/_authed/help/$section'
    | '/_authed/help/add-new'
    | '/_authed/kanban/{-$id}'
    | '/_authed/machinery/crane'
    | '/_authed/machinery/forklift'
    | '/_authed/machinery/inspection'
    | '/_authed/machinery/inspection-reports'
    | '/_authed/smartcell/$id'
    | '/kanban/order-approval/$token'
    | '/_authed/machinery/'
    | '/_authed/smartcell/'
    | '/_authed/_drawerLayout/admin/cell'
    | '/_authed/_drawerLayout/admin/machinery'
    | '/_authed/_drawerLayout/admin/notification'
    | '/_authed/_drawerLayout/admin/plant'
    | '/_authed/_drawerLayout/admin/user'
    | '/_authed/_drawerLayout/settings/user'
    | '/_authed/_drawerLayout/admin/cell/$id'
    | '/_authed/_drawerLayout/admin/cell/add-new'
    | '/_authed/_drawerLayout/admin/notification/call-help'
    | '/_authed/_drawerLayout/admin/notification/email'
    | '/_authed/_drawerLayout/admin/notification/iot-heartbeat'
    | '/_authed/_drawerLayout/admin/notification/job-notification'
    | '/_authed/_drawerLayout/admin/notification/kanban-order-approval'
    | '/_authed/_drawerLayout/admin/plant/$id'
    | '/_authed/_drawerLayout/admin/plant/add-new'
    | '/_authed/_drawerLayout/admin/user/$id'
    | '/_authed/_drawerLayout/settings/user/profile'
    | '/_authed/_drawerLayout/settings/user/security'
    | '/_authed/_drawerLayout/admin/cell/'
    | '/_authed/_drawerLayout/admin/machinery/'
    | '/_authed/_drawerLayout/admin/notification/'
    | '/_authed/_drawerLayout/admin/plant/'
    | '/_authed/_drawerLayout/admin/user/'
    | '/_authed/_drawerLayout/settings/user/'
    | '/_authed/_drawerLayout/admin/machinery/machines/$id'
    | '/_authed/_drawerLayout/admin/machinery/machines/add-new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRouteRoute: typeof AuthedRouteRouteWithChildren
  LoginRouteRoute: typeof LoginRouteRouteWithChildren
  KanbanOrderApprovalTokenRoute: typeof KanbanOrderApprovalTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_login': {
      id: '/_login'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LoginRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_login/reset-password': {
      id: '/_login/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof LoginResetPasswordRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/_login/login': {
      id: '/_login/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginLoginRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/_login/create-account': {
      id: '/_login/create-account'
      path: '/create-account'
      fullPath: '/create-account'
      preLoaderRoute: typeof LoginCreateAccountRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/_authed/welding': {
      id: '/_authed/welding'
      path: '/welding'
      fullPath: '/welding'
      preLoaderRoute: typeof AuthedWeldingRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/rfid': {
      id: '/_authed/rfid'
      path: '/rfid'
      fullPath: '/rfid'
      preLoaderRoute: typeof AuthedRfidRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/production-storage-lookup': {
      id: '/_authed/production-storage-lookup'
      path: '/production-storage-lookup'
      fullPath: '/production-storage-lookup'
      preLoaderRoute: typeof AuthedProductionStorageLookupRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/production-storage': {
      id: '/_authed/production-storage'
      path: '/production-storage'
      fullPath: '/production-storage'
      preLoaderRoute: typeof AuthedProductionStorageRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/power': {
      id: '/_authed/power'
      path: '/power'
      fullPath: '/power'
      preLoaderRoute: typeof AuthedPowerRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/ncr': {
      id: '/_authed/ncr'
      path: '/ncr'
      fullPath: '/ncr'
      preLoaderRoute: typeof AuthedNcrRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/machinery': {
      id: '/_authed/machinery'
      path: '/machinery'
      fullPath: '/machinery'
      preLoaderRoute: typeof AuthedMachineryRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/job-check': {
      id: '/_authed/job-check'
      path: '/job-check'
      fullPath: '/job-check'
      preLoaderRoute: typeof AuthedJobCheckRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/iot': {
      id: '/_authed/iot'
      path: '/iot'
      fullPath: '/iot'
      preLoaderRoute: typeof AuthedIotRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/inventory': {
      id: '/_authed/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AuthedInventoryRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/ghg': {
      id: '/_authed/ghg'
      path: '/ghg'
      fullPath: '/ghg'
      preLoaderRoute: typeof AuthedGhgRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/JobOverview': {
      id: '/_authed/JobOverview'
      path: '/JobOverview'
      fullPath: '/JobOverview'
      preLoaderRoute: typeof AuthedJobOverviewRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/smartcell': {
      id: '/_authed/smartcell'
      path: '/smartcell'
      fullPath: '/smartcell'
      preLoaderRoute: typeof AuthedSmartcellRouteRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/_drawerLayout': {
      id: '/_authed/_drawerLayout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedDrawerLayoutRouteRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/smartcell/': {
      id: '/_authed/smartcell/'
      path: '/'
      fullPath: '/smartcell/'
      preLoaderRoute: typeof AuthedSmartcellIndexRouteImport
      parentRoute: typeof AuthedSmartcellRouteRoute
    }
    '/_authed/machinery/': {
      id: '/_authed/machinery/'
      path: '/'
      fullPath: '/machinery/'
      preLoaderRoute: typeof AuthedMachineryIndexRouteImport
      parentRoute: typeof AuthedMachineryRoute
    }
    '/kanban/order-approval/$token': {
      id: '/kanban/order-approval/$token'
      path: '/kanban/order-approval/$token'
      fullPath: '/kanban/order-approval/$token'
      preLoaderRoute: typeof KanbanOrderApprovalTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/smartcell/$id': {
      id: '/_authed/smartcell/$id'
      path: '/$id'
      fullPath: '/smartcell/$id'
      preLoaderRoute: typeof AuthedSmartcellIdRouteImport
      parentRoute: typeof AuthedSmartcellRouteRoute
    }
    '/_authed/machinery/inspection-reports': {
      id: '/_authed/machinery/inspection-reports'
      path: '/inspection-reports'
      fullPath: '/machinery/inspection-reports'
      preLoaderRoute: typeof AuthedMachineryInspectionReportsRouteImport
      parentRoute: typeof AuthedMachineryRoute
    }
    '/_authed/machinery/inspection': {
      id: '/_authed/machinery/inspection'
      path: '/inspection'
      fullPath: '/machinery/inspection'
      preLoaderRoute: typeof AuthedMachineryInspectionRouteImport
      parentRoute: typeof AuthedMachineryRoute
    }
    '/_authed/machinery/forklift': {
      id: '/_authed/machinery/forklift'
      path: '/forklift'
      fullPath: '/machinery/forklift'
      preLoaderRoute: typeof AuthedMachineryForkliftRouteImport
      parentRoute: typeof AuthedMachineryRoute
    }
    '/_authed/machinery/crane': {
      id: '/_authed/machinery/crane'
      path: '/crane'
      fullPath: '/machinery/crane'
      preLoaderRoute: typeof AuthedMachineryCraneRouteImport
      parentRoute: typeof AuthedMachineryRoute
    }
    '/_authed/kanban/{-$id}': {
      id: '/_authed/kanban/{-$id}'
      path: '/kanban/{-$id}'
      fullPath: '/kanban/{-$id}'
      preLoaderRoute: typeof AuthedKanbanChar123IdChar125RouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/help/add-new': {
      id: '/_authed/help/add-new'
      path: '/help/add-new'
      fullPath: '/help/add-new'
      preLoaderRoute: typeof AuthedHelpAddNewRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/help/$section': {
      id: '/_authed/help/$section'
      path: '/help/$section'
      fullPath: '/help/$section'
      preLoaderRoute: typeof AuthedHelpSectionRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/admin/invite-user': {
      id: '/_authed/admin/invite-user'
      path: '/admin/invite-user'
      fullPath: '/admin/invite-user'
      preLoaderRoute: typeof AuthedAdminInviteUserRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/admin/TenantPermission': {
      id: '/_authed/admin/TenantPermission'
      path: '/admin/TenantPermission'
      fullPath: '/admin/TenantPermission'
      preLoaderRoute: typeof AuthedAdminTenantPermissionRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/_drawerLayout/ProjectOverview': {
      id: '/_authed/_drawerLayout/ProjectOverview'
      path: '/ProjectOverview'
      fullPath: '/ProjectOverview'
      preLoaderRoute: typeof AuthedDrawerLayoutProjectOverviewRouteImport
      parentRoute: typeof AuthedDrawerLayoutRouteRoute
    }
    '/_authed/DeviceDetails/$id': {
      id: '/_authed/DeviceDetails/$id'
      path: '/DeviceDetails/$id'
      fullPath: '/DeviceDetails/$id'
      preLoaderRoute: typeof AuthedDeviceDetailsIdRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/_drawerLayout/settings/user': {
      id: '/_authed/_drawerLayout/settings/user'
      path: '/settings/user'
      fullPath: '/settings/user'
      preLoaderRoute: typeof AuthedDrawerLayoutSettingsUserRouteRouteImport
      parentRoute: typeof AuthedDrawerLayoutRouteRoute
    }
    '/_authed/_drawerLayout/admin/user': {
      id: '/_authed/_drawerLayout/admin/user'
      path: '/admin/user'
      fullPath: '/admin/user'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminUserRouteRouteImport
      parentRoute: typeof AuthedDrawerLayoutRouteRoute
    }
    '/_authed/_drawerLayout/admin/plant': {
      id: '/_authed/_drawerLayout/admin/plant'
      path: '/admin/plant'
      fullPath: '/admin/plant'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminPlantRouteRouteImport
      parentRoute: typeof AuthedDrawerLayoutRouteRoute
    }
    '/_authed/_drawerLayout/admin/notification': {
      id: '/_authed/_drawerLayout/admin/notification'
      path: '/admin/notification'
      fullPath: '/admin/notification'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminNotificationRouteRouteImport
      parentRoute: typeof AuthedDrawerLayoutRouteRoute
    }
    '/_authed/_drawerLayout/admin/machinery': {
      id: '/_authed/_drawerLayout/admin/machinery'
      path: '/admin/machinery'
      fullPath: '/admin/machinery'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminMachineryRouteRouteImport
      parentRoute: typeof AuthedDrawerLayoutRouteRoute
    }
    '/_authed/_drawerLayout/admin/cell': {
      id: '/_authed/_drawerLayout/admin/cell'
      path: '/admin/cell'
      fullPath: '/admin/cell'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminCellRouteRouteImport
      parentRoute: typeof AuthedDrawerLayoutRouteRoute
    }
    '/_authed/_drawerLayout/settings/user/': {
      id: '/_authed/_drawerLayout/settings/user/'
      path: '/'
      fullPath: '/settings/user/'
      preLoaderRoute: typeof AuthedDrawerLayoutSettingsUserIndexRouteImport
      parentRoute: typeof AuthedDrawerLayoutSettingsUserRouteRoute
    }
    '/_authed/_drawerLayout/admin/user/': {
      id: '/_authed/_drawerLayout/admin/user/'
      path: '/'
      fullPath: '/admin/user/'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminUserIndexRouteImport
      parentRoute: typeof AuthedDrawerLayoutAdminUserRouteRoute
    }
    '/_authed/_drawerLayout/admin/plant/': {
      id: '/_authed/_drawerLayout/admin/plant/'
      path: '/'
      fullPath: '/admin/plant/'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminPlantIndexRouteImport
      parentRoute: typeof AuthedDrawerLayoutAdminPlantRouteRoute
    }
    '/_authed/_drawerLayout/admin/notification/': {
      id: '/_authed/_drawerLayout/admin/notification/'
      path: '/'
      fullPath: '/admin/notification/'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminNotificationIndexRouteImport
      parentRoute: typeof AuthedDrawerLayoutAdminNotificationRouteRoute
    }
    '/_authed/_drawerLayout/admin/machinery/': {
      id: '/_authed/_drawerLayout/admin/machinery/'
      path: '/'
      fullPath: '/admin/machinery/'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminMachineryIndexRouteImport
      parentRoute: typeof AuthedDrawerLayoutAdminMachineryRouteRoute
    }
    '/_authed/_drawerLayout/admin/cell/': {
      id: '/_authed/_drawerLayout/admin/cell/'
      path: '/'
      fullPath: '/admin/cell/'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminCellIndexRouteImport
      parentRoute: typeof AuthedDrawerLayoutAdminCellRouteRoute
    }
    '/_authed/_drawerLayout/settings/user/security': {
      id: '/_authed/_drawerLayout/settings/user/security'
      path: '/security'
      fullPath: '/settings/user/security'
      preLoaderRoute: typeof AuthedDrawerLayoutSettingsUserSecurityRouteImport
      parentRoute: typeof AuthedDrawerLayoutSettingsUserRouteRoute
    }
    '/_authed/_drawerLayout/settings/user/profile': {
      id: '/_authed/_drawerLayout/settings/user/profile'
      path: '/profile'
      fullPath: '/settings/user/profile'
      preLoaderRoute: typeof AuthedDrawerLayoutSettingsUserProfileRouteImport
      parentRoute: typeof AuthedDrawerLayoutSettingsUserRouteRoute
    }
    '/_authed/_drawerLayout/admin/user/$id': {
      id: '/_authed/_drawerLayout/admin/user/$id'
      path: '/$id'
      fullPath: '/admin/user/$id'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminUserIdRouteImport
      parentRoute: typeof AuthedDrawerLayoutAdminUserRouteRoute
    }
    '/_authed/_drawerLayout/admin/plant/add-new': {
      id: '/_authed/_drawerLayout/admin/plant/add-new'
      path: '/add-new'
      fullPath: '/admin/plant/add-new'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminPlantAddNewRouteImport
      parentRoute: typeof AuthedDrawerLayoutAdminPlantRouteRoute
    }
    '/_authed/_drawerLayout/admin/plant/$id': {
      id: '/_authed/_drawerLayout/admin/plant/$id'
      path: '/$id'
      fullPath: '/admin/plant/$id'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminPlantIdRouteImport
      parentRoute: typeof AuthedDrawerLayoutAdminPlantRouteRoute
    }
    '/_authed/_drawerLayout/admin/notification/kanban-order-approval': {
      id: '/_authed/_drawerLayout/admin/notification/kanban-order-approval'
      path: '/kanban-order-approval'
      fullPath: '/admin/notification/kanban-order-approval'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminNotificationKanbanOrderApprovalRouteImport
      parentRoute: typeof AuthedDrawerLayoutAdminNotificationRouteRoute
    }
    '/_authed/_drawerLayout/admin/notification/job-notification': {
      id: '/_authed/_drawerLayout/admin/notification/job-notification'
      path: '/job-notification'
      fullPath: '/admin/notification/job-notification'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminNotificationJobNotificationRouteImport
      parentRoute: typeof AuthedDrawerLayoutAdminNotificationRouteRoute
    }
    '/_authed/_drawerLayout/admin/notification/iot-heartbeat': {
      id: '/_authed/_drawerLayout/admin/notification/iot-heartbeat'
      path: '/iot-heartbeat'
      fullPath: '/admin/notification/iot-heartbeat'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminNotificationIotHeartbeatRouteImport
      parentRoute: typeof AuthedDrawerLayoutAdminNotificationRouteRoute
    }
    '/_authed/_drawerLayout/admin/notification/email': {
      id: '/_authed/_drawerLayout/admin/notification/email'
      path: '/email'
      fullPath: '/admin/notification/email'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminNotificationEmailRouteImport
      parentRoute: typeof AuthedDrawerLayoutAdminNotificationRouteRoute
    }
    '/_authed/_drawerLayout/admin/notification/call-help': {
      id: '/_authed/_drawerLayout/admin/notification/call-help'
      path: '/call-help'
      fullPath: '/admin/notification/call-help'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminNotificationCallHelpRouteImport
      parentRoute: typeof AuthedDrawerLayoutAdminNotificationRouteRoute
    }
    '/_authed/_drawerLayout/admin/cell/add-new': {
      id: '/_authed/_drawerLayout/admin/cell/add-new'
      path: '/add-new'
      fullPath: '/admin/cell/add-new'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminCellAddNewRouteImport
      parentRoute: typeof AuthedDrawerLayoutAdminCellRouteRoute
    }
    '/_authed/_drawerLayout/admin/cell/$id': {
      id: '/_authed/_drawerLayout/admin/cell/$id'
      path: '/$id'
      fullPath: '/admin/cell/$id'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminCellIdRouteImport
      parentRoute: typeof AuthedDrawerLayoutAdminCellRouteRoute
    }
    '/_authed/_drawerLayout/admin/machinery/machines/add-new': {
      id: '/_authed/_drawerLayout/admin/machinery/machines/add-new'
      path: '/machines/add-new'
      fullPath: '/admin/machinery/machines/add-new'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminMachineryMachinesAddNewRouteImport
      parentRoute: typeof AuthedDrawerLayoutAdminMachineryRouteRoute
    }
    '/_authed/_drawerLayout/admin/machinery/machines/$id': {
      id: '/_authed/_drawerLayout/admin/machinery/machines/$id'
      path: '/machines/$id'
      fullPath: '/admin/machinery/machines/$id'
      preLoaderRoute: typeof AuthedDrawerLayoutAdminMachineryMachinesIdRouteImport
      parentRoute: typeof AuthedDrawerLayoutAdminMachineryRouteRoute
    }
  }
}

interface AuthedDrawerLayoutAdminCellRouteRouteChildren {
  AuthedDrawerLayoutAdminCellIdRoute: typeof AuthedDrawerLayoutAdminCellIdRoute
  AuthedDrawerLayoutAdminCellAddNewRoute: typeof AuthedDrawerLayoutAdminCellAddNewRoute
  AuthedDrawerLayoutAdminCellIndexRoute: typeof AuthedDrawerLayoutAdminCellIndexRoute
}

const AuthedDrawerLayoutAdminCellRouteRouteChildren: AuthedDrawerLayoutAdminCellRouteRouteChildren =
  {
    AuthedDrawerLayoutAdminCellIdRoute: AuthedDrawerLayoutAdminCellIdRoute,
    AuthedDrawerLayoutAdminCellAddNewRoute:
      AuthedDrawerLayoutAdminCellAddNewRoute,
    AuthedDrawerLayoutAdminCellIndexRoute:
      AuthedDrawerLayoutAdminCellIndexRoute,
  }

const AuthedDrawerLayoutAdminCellRouteRouteWithChildren =
  AuthedDrawerLayoutAdminCellRouteRoute._addFileChildren(
    AuthedDrawerLayoutAdminCellRouteRouteChildren,
  )

interface AuthedDrawerLayoutAdminMachineryRouteRouteChildren {
  AuthedDrawerLayoutAdminMachineryIndexRoute: typeof AuthedDrawerLayoutAdminMachineryIndexRoute
  AuthedDrawerLayoutAdminMachineryMachinesIdRoute: typeof AuthedDrawerLayoutAdminMachineryMachinesIdRoute
  AuthedDrawerLayoutAdminMachineryMachinesAddNewRoute: typeof AuthedDrawerLayoutAdminMachineryMachinesAddNewRoute
}

const AuthedDrawerLayoutAdminMachineryRouteRouteChildren: AuthedDrawerLayoutAdminMachineryRouteRouteChildren =
  {
    AuthedDrawerLayoutAdminMachineryIndexRoute:
      AuthedDrawerLayoutAdminMachineryIndexRoute,
    AuthedDrawerLayoutAdminMachineryMachinesIdRoute:
      AuthedDrawerLayoutAdminMachineryMachinesIdRoute,
    AuthedDrawerLayoutAdminMachineryMachinesAddNewRoute:
      AuthedDrawerLayoutAdminMachineryMachinesAddNewRoute,
  }

const AuthedDrawerLayoutAdminMachineryRouteRouteWithChildren =
  AuthedDrawerLayoutAdminMachineryRouteRoute._addFileChildren(
    AuthedDrawerLayoutAdminMachineryRouteRouteChildren,
  )

interface AuthedDrawerLayoutAdminNotificationRouteRouteChildren {
  AuthedDrawerLayoutAdminNotificationCallHelpRoute: typeof AuthedDrawerLayoutAdminNotificationCallHelpRoute
  AuthedDrawerLayoutAdminNotificationEmailRoute: typeof AuthedDrawerLayoutAdminNotificationEmailRoute
  AuthedDrawerLayoutAdminNotificationIotHeartbeatRoute: typeof AuthedDrawerLayoutAdminNotificationIotHeartbeatRoute
  AuthedDrawerLayoutAdminNotificationJobNotificationRoute: typeof AuthedDrawerLayoutAdminNotificationJobNotificationRoute
  AuthedDrawerLayoutAdminNotificationKanbanOrderApprovalRoute: typeof AuthedDrawerLayoutAdminNotificationKanbanOrderApprovalRoute
  AuthedDrawerLayoutAdminNotificationIndexRoute: typeof AuthedDrawerLayoutAdminNotificationIndexRoute
}

const AuthedDrawerLayoutAdminNotificationRouteRouteChildren: AuthedDrawerLayoutAdminNotificationRouteRouteChildren =
  {
    AuthedDrawerLayoutAdminNotificationCallHelpRoute:
      AuthedDrawerLayoutAdminNotificationCallHelpRoute,
    AuthedDrawerLayoutAdminNotificationEmailRoute:
      AuthedDrawerLayoutAdminNotificationEmailRoute,
    AuthedDrawerLayoutAdminNotificationIotHeartbeatRoute:
      AuthedDrawerLayoutAdminNotificationIotHeartbeatRoute,
    AuthedDrawerLayoutAdminNotificationJobNotificationRoute:
      AuthedDrawerLayoutAdminNotificationJobNotificationRoute,
    AuthedDrawerLayoutAdminNotificationKanbanOrderApprovalRoute:
      AuthedDrawerLayoutAdminNotificationKanbanOrderApprovalRoute,
    AuthedDrawerLayoutAdminNotificationIndexRoute:
      AuthedDrawerLayoutAdminNotificationIndexRoute,
  }

const AuthedDrawerLayoutAdminNotificationRouteRouteWithChildren =
  AuthedDrawerLayoutAdminNotificationRouteRoute._addFileChildren(
    AuthedDrawerLayoutAdminNotificationRouteRouteChildren,
  )

interface AuthedDrawerLayoutAdminPlantRouteRouteChildren {
  AuthedDrawerLayoutAdminPlantIdRoute: typeof AuthedDrawerLayoutAdminPlantIdRoute
  AuthedDrawerLayoutAdminPlantAddNewRoute: typeof AuthedDrawerLayoutAdminPlantAddNewRoute
  AuthedDrawerLayoutAdminPlantIndexRoute: typeof AuthedDrawerLayoutAdminPlantIndexRoute
}

const AuthedDrawerLayoutAdminPlantRouteRouteChildren: AuthedDrawerLayoutAdminPlantRouteRouteChildren =
  {
    AuthedDrawerLayoutAdminPlantIdRoute: AuthedDrawerLayoutAdminPlantIdRoute,
    AuthedDrawerLayoutAdminPlantAddNewRoute:
      AuthedDrawerLayoutAdminPlantAddNewRoute,
    AuthedDrawerLayoutAdminPlantIndexRoute:
      AuthedDrawerLayoutAdminPlantIndexRoute,
  }

const AuthedDrawerLayoutAdminPlantRouteRouteWithChildren =
  AuthedDrawerLayoutAdminPlantRouteRoute._addFileChildren(
    AuthedDrawerLayoutAdminPlantRouteRouteChildren,
  )

interface AuthedDrawerLayoutAdminUserRouteRouteChildren {
  AuthedDrawerLayoutAdminUserIdRoute: typeof AuthedDrawerLayoutAdminUserIdRoute
  AuthedDrawerLayoutAdminUserIndexRoute: typeof AuthedDrawerLayoutAdminUserIndexRoute
}

const AuthedDrawerLayoutAdminUserRouteRouteChildren: AuthedDrawerLayoutAdminUserRouteRouteChildren =
  {
    AuthedDrawerLayoutAdminUserIdRoute: AuthedDrawerLayoutAdminUserIdRoute,
    AuthedDrawerLayoutAdminUserIndexRoute:
      AuthedDrawerLayoutAdminUserIndexRoute,
  }

const AuthedDrawerLayoutAdminUserRouteRouteWithChildren =
  AuthedDrawerLayoutAdminUserRouteRoute._addFileChildren(
    AuthedDrawerLayoutAdminUserRouteRouteChildren,
  )

interface AuthedDrawerLayoutSettingsUserRouteRouteChildren {
  AuthedDrawerLayoutSettingsUserProfileRoute: typeof AuthedDrawerLayoutSettingsUserProfileRoute
  AuthedDrawerLayoutSettingsUserSecurityRoute: typeof AuthedDrawerLayoutSettingsUserSecurityRoute
  AuthedDrawerLayoutSettingsUserIndexRoute: typeof AuthedDrawerLayoutSettingsUserIndexRoute
}

const AuthedDrawerLayoutSettingsUserRouteRouteChildren: AuthedDrawerLayoutSettingsUserRouteRouteChildren =
  {
    AuthedDrawerLayoutSettingsUserProfileRoute:
      AuthedDrawerLayoutSettingsUserProfileRoute,
    AuthedDrawerLayoutSettingsUserSecurityRoute:
      AuthedDrawerLayoutSettingsUserSecurityRoute,
    AuthedDrawerLayoutSettingsUserIndexRoute:
      AuthedDrawerLayoutSettingsUserIndexRoute,
  }

const AuthedDrawerLayoutSettingsUserRouteRouteWithChildren =
  AuthedDrawerLayoutSettingsUserRouteRoute._addFileChildren(
    AuthedDrawerLayoutSettingsUserRouteRouteChildren,
  )

interface AuthedDrawerLayoutRouteRouteChildren {
  AuthedDrawerLayoutProjectOverviewRoute: typeof AuthedDrawerLayoutProjectOverviewRoute
  AuthedDrawerLayoutAdminCellRouteRoute: typeof AuthedDrawerLayoutAdminCellRouteRouteWithChildren
  AuthedDrawerLayoutAdminMachineryRouteRoute: typeof AuthedDrawerLayoutAdminMachineryRouteRouteWithChildren
  AuthedDrawerLayoutAdminNotificationRouteRoute: typeof AuthedDrawerLayoutAdminNotificationRouteRouteWithChildren
  AuthedDrawerLayoutAdminPlantRouteRoute: typeof AuthedDrawerLayoutAdminPlantRouteRouteWithChildren
  AuthedDrawerLayoutAdminUserRouteRoute: typeof AuthedDrawerLayoutAdminUserRouteRouteWithChildren
  AuthedDrawerLayoutSettingsUserRouteRoute: typeof AuthedDrawerLayoutSettingsUserRouteRouteWithChildren
}

const AuthedDrawerLayoutRouteRouteChildren: AuthedDrawerLayoutRouteRouteChildren =
  {
    AuthedDrawerLayoutProjectOverviewRoute:
      AuthedDrawerLayoutProjectOverviewRoute,
    AuthedDrawerLayoutAdminCellRouteRoute:
      AuthedDrawerLayoutAdminCellRouteRouteWithChildren,
    AuthedDrawerLayoutAdminMachineryRouteRoute:
      AuthedDrawerLayoutAdminMachineryRouteRouteWithChildren,
    AuthedDrawerLayoutAdminNotificationRouteRoute:
      AuthedDrawerLayoutAdminNotificationRouteRouteWithChildren,
    AuthedDrawerLayoutAdminPlantRouteRoute:
      AuthedDrawerLayoutAdminPlantRouteRouteWithChildren,
    AuthedDrawerLayoutAdminUserRouteRoute:
      AuthedDrawerLayoutAdminUserRouteRouteWithChildren,
    AuthedDrawerLayoutSettingsUserRouteRoute:
      AuthedDrawerLayoutSettingsUserRouteRouteWithChildren,
  }

const AuthedDrawerLayoutRouteRouteWithChildren =
  AuthedDrawerLayoutRouteRoute._addFileChildren(
    AuthedDrawerLayoutRouteRouteChildren,
  )

interface AuthedSmartcellRouteRouteChildren {
  AuthedSmartcellIdRoute: typeof AuthedSmartcellIdRoute
  AuthedSmartcellIndexRoute: typeof AuthedSmartcellIndexRoute
}

const AuthedSmartcellRouteRouteChildren: AuthedSmartcellRouteRouteChildren = {
  AuthedSmartcellIdRoute: AuthedSmartcellIdRoute,
  AuthedSmartcellIndexRoute: AuthedSmartcellIndexRoute,
}

const AuthedSmartcellRouteRouteWithChildren =
  AuthedSmartcellRouteRoute._addFileChildren(AuthedSmartcellRouteRouteChildren)

interface AuthedMachineryRouteChildren {
  AuthedMachineryCraneRoute: typeof AuthedMachineryCraneRoute
  AuthedMachineryForkliftRoute: typeof AuthedMachineryForkliftRoute
  AuthedMachineryInspectionRoute: typeof AuthedMachineryInspectionRoute
  AuthedMachineryInspectionReportsRoute: typeof AuthedMachineryInspectionReportsRoute
  AuthedMachineryIndexRoute: typeof AuthedMachineryIndexRoute
}

const AuthedMachineryRouteChildren: AuthedMachineryRouteChildren = {
  AuthedMachineryCraneRoute: AuthedMachineryCraneRoute,
  AuthedMachineryForkliftRoute: AuthedMachineryForkliftRoute,
  AuthedMachineryInspectionRoute: AuthedMachineryInspectionRoute,
  AuthedMachineryInspectionReportsRoute: AuthedMachineryInspectionReportsRoute,
  AuthedMachineryIndexRoute: AuthedMachineryIndexRoute,
}

const AuthedMachineryRouteWithChildren = AuthedMachineryRoute._addFileChildren(
  AuthedMachineryRouteChildren,
)

interface AuthedRouteRouteChildren {
  AuthedDrawerLayoutRouteRoute: typeof AuthedDrawerLayoutRouteRouteWithChildren
  AuthedSmartcellRouteRoute: typeof AuthedSmartcellRouteRouteWithChildren
  AuthedJobOverviewRoute: typeof AuthedJobOverviewRoute
  AuthedGhgRoute: typeof AuthedGhgRoute
  AuthedInventoryRoute: typeof AuthedInventoryRoute
  AuthedIotRoute: typeof AuthedIotRoute
  AuthedJobCheckRoute: typeof AuthedJobCheckRoute
  AuthedMachineryRoute: typeof AuthedMachineryRouteWithChildren
  AuthedNcrRoute: typeof AuthedNcrRoute
  AuthedPowerRoute: typeof AuthedPowerRoute
  AuthedProductionStorageRoute: typeof AuthedProductionStorageRoute
  AuthedProductionStorageLookupRoute: typeof AuthedProductionStorageLookupRoute
  AuthedRfidRoute: typeof AuthedRfidRoute
  AuthedWeldingRoute: typeof AuthedWeldingRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedDeviceDetailsIdRoute: typeof AuthedDeviceDetailsIdRoute
  AuthedAdminTenantPermissionRoute: typeof AuthedAdminTenantPermissionRoute
  AuthedAdminInviteUserRoute: typeof AuthedAdminInviteUserRoute
  AuthedHelpSectionRoute: typeof AuthedHelpSectionRoute
  AuthedHelpAddNewRoute: typeof AuthedHelpAddNewRoute
  AuthedKanbanChar123IdChar125Route: typeof AuthedKanbanChar123IdChar125Route
}

const AuthedRouteRouteChildren: AuthedRouteRouteChildren = {
  AuthedDrawerLayoutRouteRoute: AuthedDrawerLayoutRouteRouteWithChildren,
  AuthedSmartcellRouteRoute: AuthedSmartcellRouteRouteWithChildren,
  AuthedJobOverviewRoute: AuthedJobOverviewRoute,
  AuthedGhgRoute: AuthedGhgRoute,
  AuthedInventoryRoute: AuthedInventoryRoute,
  AuthedIotRoute: AuthedIotRoute,
  AuthedJobCheckRoute: AuthedJobCheckRoute,
  AuthedMachineryRoute: AuthedMachineryRouteWithChildren,
  AuthedNcrRoute: AuthedNcrRoute,
  AuthedPowerRoute: AuthedPowerRoute,
  AuthedProductionStorageRoute: AuthedProductionStorageRoute,
  AuthedProductionStorageLookupRoute: AuthedProductionStorageLookupRoute,
  AuthedRfidRoute: AuthedRfidRoute,
  AuthedWeldingRoute: AuthedWeldingRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedDeviceDetailsIdRoute: AuthedDeviceDetailsIdRoute,
  AuthedAdminTenantPermissionRoute: AuthedAdminTenantPermissionRoute,
  AuthedAdminInviteUserRoute: AuthedAdminInviteUserRoute,
  AuthedHelpSectionRoute: AuthedHelpSectionRoute,
  AuthedHelpAddNewRoute: AuthedHelpAddNewRoute,
  AuthedKanbanChar123IdChar125Route: AuthedKanbanChar123IdChar125Route,
}

const AuthedRouteRouteWithChildren = AuthedRouteRoute._addFileChildren(
  AuthedRouteRouteChildren,
)

interface LoginRouteRouteChildren {
  LoginCreateAccountRoute: typeof LoginCreateAccountRoute
  LoginLoginRoute: typeof LoginLoginRoute
  LoginResetPasswordRoute: typeof LoginResetPasswordRoute
}

const LoginRouteRouteChildren: LoginRouteRouteChildren = {
  LoginCreateAccountRoute: LoginCreateAccountRoute,
  LoginLoginRoute: LoginLoginRoute,
  LoginResetPasswordRoute: LoginResetPasswordRoute,
}

const LoginRouteRouteWithChildren = LoginRouteRoute._addFileChildren(
  LoginRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthedRouteRoute: AuthedRouteRouteWithChildren,
  LoginRouteRoute: LoginRouteRouteWithChildren,
  KanbanOrderApprovalTokenRoute: KanbanOrderApprovalTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
